import React, { useState, useRef, FocusEvent } from "react";
import TextareaAutosize from "react-textarea-autosize";
import classnames from "classnames";
import Popover from "../popover";
import style from "./style.module.scss";
import type { LimitedInputProps } from "../../types";

const DEFAULT_MAX_LENGTH = 25;

export function LimitedInput({
  value,
  onChange,
  onBlur,
  placeholder,
  className,
  type = "input",
  maxLength = DEFAULT_MAX_LENGTH,
  containerClassName,
  containerStyle,
}: LimitedInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLElement>(null);
  const Component = type === "textarea" ? TextareaAutosize : "input";

  return (
    <div className={classnames(style.container, containerClassName)} style={containerStyle}>
      <Component
        ref={inputRef as React.RefObject<HTMLInputElement> & React.RefObject<HTMLTextAreaElement>}
        className={className}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={(e: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          setIsFocused(false);
          onBlur?.(e);
        }}
      />
      <Popover
        anchorRef={inputRef}
        open={isFocused}
        placement="bottom-center"
        offset={4}
        className={style.counter}
      >
        {`${(value || "").length}/${maxLength}`}
      </Popover>
    </div>
  );
}

export default LimitedInput;
